const FormLabel = {
    baseStyle: {
        field: { color: 'green', fontSize: '16px' },
    },
}

export default FormLabel;
